import { render, staticRenderFns } from "./base-input-wrap.vue?vue&type=template&id=dab90b08&scoped=true&"
import script from "./base-input-wrap.vue?vue&type=script&lang=js&"
export * from "./base-input-wrap.vue?vue&type=script&lang=js&"
import style0 from "./base-input-wrap.vue?vue&type=style&index=0&id=dab90b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab90b08",
  null
  
)

export default component.exports